import React, { useCallback, useContext, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import LockclosedIcon from 'icons/Lockclosed.icon';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import { Button, Loader } from 'ncoded-component-library';
import api from '../../api';
import { useParams } from 'react-router-dom';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import ShareableLinkNdaProcessing from '../ShareableLinkNdaProcessing';

import './ShareableLinkNdaSign.styles.scss';

type ShareableLinkNdaSignProps = {
  className?: string;
  isProcessing: boolean;
};

const ShareableLinkNdaSign: React.FC<ShareableLinkNdaSignProps> = (props) => {
  const { className, isProcessing } = props;

  const { shareableLinkId } = useParams<{ shareableLinkId: string }>();

  const [isLoading, setIsLoading] = useState(false);

  const { popServerError } = useContext(PopNotificationsContext);

  const classes = classNames('shareable-link-nda-sign', className);

  const { t } = useTranslation();

  const onNdaClick = useCallback(async () => {
    try {
      setIsLoading(true);

      const { data } = await api.shareableLinks.getNDADocusignUrl(
        shareableLinkId,
      );

      if (data?.url) window.location.href = data.url;
    } catch (e) {
      popServerError(e);
    } finally {
      setIsLoading(false);
    }
  }, [shareableLinkId, popServerError]);

  if (isProcessing) {
    return <ShareableLinkNdaProcessing />;
  }

  return (
    <ShareableLinkLockScreen className={classes} title={t('signNdaToAccess')}>
      <Button variant="outline" disabled={isLoading} onClick={onNdaClick}>
        {isLoading ? (
          <Loader size="small" />
        ) : (
          <>
            <LockclosedIcon />
            {t('reviewAndSignNda')}
          </>
        )}
      </Button>
    </ShareableLinkLockScreen>
  );
};

export default ShareableLinkNdaSign;
